/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assert} from 'Asserts';
import ExportAuditLogButton from 'audit/ExportAuditLogButton';
import {setWindowTitle} from 'BenchlingUtil';
import DataConnector from 'connect/DataConnector';
import * as RegistryConstants from 'constants/RegistryConstants';
import {LabelTemplate} from 'constants/SampleConstants';
import * as LabelPrintingActions from 'label-printing/LabelPrintingActions';
import navigateToURL from 'lib/navigateToURL';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as StorableActions from 'samples/StorableActions';
import StorableStore from 'samples/StorableStore';
import LabelTemplateSettings from 'settings/label-printing/LabelTemplateSettings';
import SettingsPageContainer from 'settings/SettingsPageContainer';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

class LabelTemplateSettingsPageConnector extends DataConnector<
  BaseLabelTemplateSettingsPageProps,
  EnhancedProps
> {
  override storableStore: any;
  override stores = [StorableStore];
  override shouldSubscribeToRedux = false;

  enhanceProps(): EnhancedProps {
    let newState: EnhancedProps = {
      savingState: this.storableStore().getSavingState(),
    };
    if (this.props.labelTemplateId) {
      newState = {
        ...newState,
        labelTemplate: this.storableStore().getLabelTemplate(this.props.labelTemplateId),
      };
    }
    return {
      ...newState,
    };
  }
}

export interface BaseLabelTemplateSettingsPageProps {
  labelTemplateId?: string;
  ownerUrlId: string;
  registryId: string;
}
interface EnhancedProps {
  savingState: RegistryConstants.SavingState;
  labelTemplate?: LabelTemplate;
}

interface QueryingProps {
  isWritable: boolean;
}

class LabelTemplateSettingsPage extends React.Component<
  BaseLabelTemplateSettingsPageProps & QueryingProps & EnhancedProps
> {
  override componentDidMount(): void {
    this._fetchLabelTemplates();
  }

  override componentDidUpdate(prevProps: BaseLabelTemplateSettingsPageProps & EnhancedProps): void {
    if (
      prevProps.savingState === RegistryConstants.SavingState.PENDING &&
      RegistryUtil.isSavingFinished(this.props.savingState)
    ) {
      StorableActions.resetSavingState();
    }
    if (this.props.labelTemplateId !== prevProps.labelTemplateId) {
      this._fetchLabelTemplates();
    }
  }

  _fetchLabelTemplates = (): void => {
    LabelPrintingActions.fetchLabelTemplates();
  };

  _handleNavigateToLabelTemplates = (): void => {
    navigateToURL(RegistryUtil.getRegistryLabelTemplatesUrl(this.props.ownerUrlId, this.props.registryId));
  };

  _handleCreate = (labelTemplate: Pick<LabelTemplate, 'name' | 'zplTemplate'>): void => {
    LabelPrintingActions.createLabelTemplate(this.props.registryId, this.props.ownerUrlId, labelTemplate);
  };

  _handleUpdate = (labelTemplate: {name?: string; zplTemplate?: string}): void => {
    assert(this.props.labelTemplateId != null, 'labelTemplateId must exist for update.');
    if (this.props.labelTemplateId) {
      LabelPrintingActions.updateLabelTemplate(this.props.labelTemplateId, labelTemplate);
    }
  };

  override render(): JSX.Element {
    if (this.props.labelTemplate) {
      setWindowTitle(`${this.props.labelTemplate.name} - Label Templates`);
    }

    return (
      <SettingsPageContainer
        onClickTitle={this._handleNavigateToLabelTemplates}
        subtitle={this.props.labelTemplateId && this.props.labelTemplate ? this.props.labelTemplate.name : ''}
        title="Label Templates"
        toolbar={
          this.props.labelTemplateId && (
            <ExportAuditLogButton
              ids={[this.props.labelTemplateId]}
              buttonSize={ButtonSize.MEDIUM}
              buttonStyle={ButtonStyle.TERTIARY_GRAY}
            />
          )
        }
      >
        {this.props.labelTemplateId && !this.props.labelTemplate ? (
          <HorizontalThrobber />
        ) : (
          <LabelTemplateSettings
            isBeingCreated={!this.props.labelTemplateId}
            isWritable={this.props.isWritable}
            labelTemplate={this.props.labelTemplate}
            onCreate={this._handleCreate}
            onUpdate={this._handleUpdate}
            savingState={this.props.savingState}
          />
        )}
      </SettingsPageContainer>
    );
  }
}

function QueryingLabelTemplateSettingsPage(
  props: BaseLabelTemplateSettingsPageProps & EnhancedProps
): JSX.Element {
  const isWritable = RegistryUtil.useIsRegistryWritableQuery(props.registryId);
  return <LabelTemplateSettingsPage {...props} isWritable={isWritable} />;
}

export default LabelTemplateSettingsPageConnector.connect(QueryingLabelTemplateSettingsPage);
